import { flow } from "mobx";
import { request } from "../utils/request.js";
import { locationRestMovePost } from "../wp-api/move.post.js";
import { locationRestPostFirstTimePointerDelete } from "../wp-api/post-first-time-pointer.delete.js";
class PostsStore {
    /* v8 ignore next 3 */ constructor(rootStore){
        this.updateBySequence = flow(function*(sequence) {
            yield request({
                location: locationRestMovePost,
                request: {
                    type: "post",
                    sequence
                }
            });
        });
        this.dismissFirstTimePointer = flow(function*() {
            yield request({
                location: locationRestPostFirstTimePointerDelete
            });
            this.rootStore.optionStore.others.types.post.showPostFirstTimePointer = false;
        });
        this.rootStore = rootStore;
    }
}
export { PostsStore };
